import { ActionType } from "../actions/ActionTypes";
// import { Action } from "../actions";

export interface PlanState {
  plan: any;
  error: string;
  loading: boolean;
  upcoming_plans: any;
}

const initialState: PlanState = {
  plan: {},
  error: "",
  loading: false,
  upcoming_plans: {},
};

const reducer = (state: object = initialState, action: any): any => {
  switch (action.type) {
    case ActionType.GET_CURRENT_PLAN_INIT:
      return {
        ...state,
        error: "",
        loading: true,
      };
    case ActionType.GET_CURRENT_PLAN_SUCCESS:
      return {
        ...state,
        loading: false,
        plan: action.payload || {},
      };
    case ActionType.GET_CURRENT_PLAN_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    case ActionType.GET_UPCOMING_PLAN_INIT:
      return {
        ...state,
        error: "",
        loading: true,
      };
    case ActionType.GET_UPCOMING_PLAN_SUCCESS:
      return {
        ...state,
        loading: false,
        upcoming_plans: action.payload || {},
      };
    case ActionType.GET_UPCOMING_PLAN_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    default:
      return state;
  }
};

export default reducer;
